<div class="ai-natural-language-input">
    <!-- Header -->
    <div class="flex align-items-center gap-2 mb-3">
        <i class="fa-solid fa-comment-dots text-primary text-xl"></i>
        <span class="text-lg font-semibold">Natürlichsprachliche Abfrage</span>
    </div>

    <p class="text-sm text-500 mb-3">
        Beschreiben Sie Ihre Zielgruppe in einfacher Sprache und die KI generiert die Filterkriterien.
    </p>

    <!-- Input Section -->
    <div class="flex flex-column gap-3">
        <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
                <i class="fa-solid fa-wand-magic-sparkles"></i>
            </span>
            <textarea
                pInputTextarea
                [(ngModel)]="query"
                [rows]="2"
                class="w-full"
                placeholder="z.B. 'Aktive Kunden in Berlin, die in den letzten 30 Tagen gekauft haben'"
                [disabled]="processing">
            </textarea>
        </div>

        <div class="flex align-items-center justify-content-between">
            <p-button
                label="Beispiele anzeigen"
                icon="fa-solid fa-lightbulb"
                styleClass="p-button-text p-button-sm"
                (onClick)="showExamples = !showExamples">
            </p-button>
            <div class="flex gap-2">
                <p-button
                    label="Zurücksetzen"
                    styleClass="p-button-outlined p-button-secondary p-button-sm"
                    (onClick)="reset()"
                    *ngIf="query || response">
                </p-button>
                <p-button
                    label="Kriterien generieren"
                    icon="fa-solid fa-sparkles"
                    (onClick)="processQuery()"
                    [loading]="processing"
                    [disabled]="!query.trim()">
                </p-button>
            </div>
        </div>
    </div>

    <!-- Examples Panel -->
    <div *ngIf="showExamples" class="mt-3 p-3 bg-gray-100 border-round">
        <div class="text-sm font-medium mb-2">Beispielabfragen:</div>
        <div class="flex flex-column gap-2">
            <div *ngFor="let example of exampleQueries"
                 class="p-2 bg-white border-round cursor-pointer hover:surface-200"
                 (click)="useExample(example)">
                <i class="fa-solid fa-arrow-right text-primary mr-2"></i>
                <span class="text-sm">{{ example }}</span>
            </div>
        </div>
    </div>

    <!-- Error Message -->
    <p-message *ngIf="errorMessage" severity="error" [text]="errorMessage" styleClass="mt-3 w-full"></p-message>

    <!-- Processing Indicator -->
    <div *ngIf="processing" class="flex align-items-center justify-content-center p-4 mt-3">
        <i class="fa-solid fa-spinner fa-spin text-2xl text-primary mr-2"></i>
        <span>Ihre Abfrage wird verarbeitet...</span>
    </div>

    <!-- Response Section -->
    <div *ngIf="response && !processing" class="mt-4">
        <!-- Needs Clarification -->
        <div *ngIf="response.ambiguities?.length > 0" class="p-card">
            <div class="p-card-body">
                <div class="flex align-items-center gap-2 mb-3">
                    <i class="fa-solid fa-question-circle text-yellow-600"></i>
                    <span class="font-medium">Klärung erforderlich</span>
                </div>

                <div *ngFor="let ambiguity of response.ambiguities" class="mb-4">
                    <div class="text-sm mb-2">
                        <span class="font-medium">{{ ambiguity.term }}:</span>
                        {{ ambiguity.issue }}
                    </div>
                    <div class="flex flex-wrap gap-2">
                        <p-button
                            *ngFor="let suggestion of ambiguity.suggestions"
                            [label]="suggestion"
                            styleClass="p-button-sm p-button-outlined"
                            [class.p-button-primary]="clarifications[ambiguity.term] === suggestion"
                            (onClick)="selectClarification(ambiguity, suggestion)">
                        </p-button>
                    </div>
                </div>

                <div class="flex justify-content-end">
                    <p-button
                        label="Klärungen übernehmen"
                        icon="fa-solid fa-check"
                        (onClick)="provideClarification()"
                        [disabled]="!hasClarifications()">
                    </p-button>
                </div>
            </div>
        </div>

        <!-- Success Response -->
        <div *ngIf="response.success && (!response.ambiguities || response.ambiguities.length === 0)" class="p-card">
            <div class="p-card-body">
                <div class="flex align-items-center justify-content-between mb-3">
                    <div class="flex align-items-center gap-2">
                        <i class="fa-solid fa-check-circle text-green-600"></i>
                        <span class="font-medium">Kriterien generiert</span>
                    </div>
                    <span class="text-sm" [ngClass]="getConfidenceColor(response.confidenceScore)">
                        {{ getConfidenceLabel(response.confidenceScore) }}
                        ({{ (response.confidenceScore * 100) | number:'1.0-0' }}%)
                    </span>
                </div>

                <!-- Interpretation -->
                <div class="mb-3 p-3 bg-gray-100 border-round">
                    <div class="text-xs text-500 mb-1">Interpretation</div>
                    <div class="text-sm">{{ response.interpretation }}</div>
                </div>

                <!-- Estimated Count -->
                <div class="flex align-items-center gap-4 mb-3">
                    <div>
                        <div class="text-xs text-500">Geschätzte Mitglieder</div>
                        <div class="text-lg font-semibold">{{ response.estimatedMemberCount | number }}</div>
                    </div>
                </div>

                <!-- Actions -->
                <div class="flex justify-content-end gap-2">
                    <p-button
                        label="Abfrage ändern"
                        styleClass="p-button-outlined"
                        (onClick)="reset()">
                    </p-button>
                    <p-button
                        label="Kriterien übernehmen"
                        icon="fa-solid fa-check"
                        (onClick)="acceptCriteria()">
                    </p-button>
                </div>
            </div>
        </div>
    </div>
</div>
